export const HELP_SECTION_EMAIL = 'hello@elevatedliving.com'
export const HELP_SECTION_SUBJECT = 'Visitor%20Parking%20Support%20Request'
export const TICKET_NUMBER_URL_KEY = 'ticketNumber'

export const getHelpSectionUrl = (ticketNumber?: string | null) => {
  const baseUrl = `mailto:${HELP_SECTION_EMAIL}?subject=${HELP_SECTION_SUBJECT}`

  if (!ticketNumber) {
    return baseUrl
  }

  const body = encodeURIComponent(`Ticket Number: ${ticketNumber}\n\n`)
  return `${baseUrl}&body=${body}`
}
